import React from "react";
import { cn } from "../utls/utils";

export type SpinnerSize = "sm" | "md" | "lg";

export interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
}

const containerSize: Record<SpinnerSize, string> = {
  sm: "w-6 h-6",
  md: "w-10 h-10",
  lg: "w-16 h-16",
};

const borderSize: Record<SpinnerSize, string> = {
  sm: "border-2",
  md: "border-4",
  lg: "border-4",
};

const logoSize: Record<SpinnerSize, string> = {
  sm: "w-3",
  md: "w-4",
  lg: "w-6",
};

export const ThemedSpinner: React.FC<SpinnerProps> = ({
  size = "md",
  className,
}) => {
  return (
    <div
      role="status"
      className={cn(
        "relative inline-flex items-center justify-center",
        containerSize[size],
        className
      )}
    >
      <div
        className={cn(
          "absolute inset-0 rounded-full border-terracotta-300 border-t-terracotta-500 animate-spin",
          borderSize[size]
        )}
      />
      <img
        src={`${process.env.PUBLIC_URL}/images/harper-logo.png`}
        alt="Harper Logo"
        className={cn("object-contain", logoSize[size])}
      />
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default ThemedSpinner;
